import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth.service';
import { User } from '@features/user/interfaces/user.interface';
import { UserService } from '@features/user/services/user.service';
import {
  faAngleRight,
  faArrowRightFromBracket,
  faBagShopping,
  faComment,
  faCreditCard,
  faGauge,
  faHeart,
  faPlus,
  faUser,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fc-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.css'],
})
export class UserDropdownComponent implements OnInit {
  // declare font awesome icons
  faUser = faUser;
  faAngleRight = faAngleRight;
  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faGauge = faGauge;
  faBagShopping = faBagShopping;
  faComment = faComment;
  faWandMagicSparkles = faWandMagicSparkles;
  faHeart = faHeart;
  faArrowRightFromBracket = faArrowRightFromBracket;

  user?: User;
  quickLinks = [
    {
      title: 'Dashboard',
      icon: faGauge,
      action: () => this.navigateTo('/user/dashboard'),
    },
    {
      title: 'My Orders',
      icon: faBagShopping,
      action: () => this.navigateTo('/user/order'),
    },
    {
      title: 'Product Review',
      icon: faComment,

      action: () => this.navigateTo('/user/review'),
    },
    {
      title: 'My Beauty Book',
      icon: faWandMagicSparkles,
      action: () => this.navigateTo('/user/beautybook-post'),
    },
    {
      title: 'Wishlist',
      icon: faHeart,
      action: () => this.navigateTo('/user/wishlist'),
    },
    {
      title: 'Logout',
      icon: faArrowRightFromBracket,
      action: () => this.logout(),
    },
  ];
  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UserService
  ) {
    this.userService.currentUserValue.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {}
  logout() {
    this.authService.logout().subscribe();
  }
  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
